// extracted by mini-css-extract-plugin
export default {"defLabel":"DefaultLabel_defLabel__QZChX","requiredMark":"DefaultLabel_requiredMark__3mFXI"};